import { useParams } from 'react-router';

import {
  Container,
  ContainerContent,
  ContainerHeader,
  ContainerOverview,
  ModelingDetailPageHeader,
  ModelingDetailPageOverview,
} from '@/component';
import ModelingDetailPageContent from '@/component/Modeling/ModelingDetailPageContent';
import { VTab } from '@/package';

const ModelingDetailPage = () => {
  const { modelingId } = useParams();

  return (
    <Container>
      <ContainerOverview>
        <ModelingDetailPageOverview modelingId={Number(modelingId)} />
      </ContainerOverview>

      <VTab
        className="relative z-10 flex w-full flex-col items-center overflow-y-auto"
        defaultValue="2"
      >
        <ContainerHeader>
          <ModelingDetailPageHeader />
        </ContainerHeader>

        <ContainerContent>
          <ModelingDetailPageContent />
        </ContainerContent>
      </VTab>
    </Container>
  );
};

export default ModelingDetailPage;
